import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/authConfig';
import { apiClient } from './api/apiClient';
import { setupAuthInterceptor } from './api/authInterceptor';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Setup authentication interceptor for API calls
setupAuthInterceptor(apiClient, msalInstance);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();